<template>
  
  <div class="card-color">

    <color-blocks
      :colors="colors"
      :value="value"
      @input="(color) => $emit('input', color)"
    ></color-blocks>

    <v-layout align-center class="border-top pa-1 white lighten-2">
      <v-btn color="grey darken-1" dark @click="$emit('cancel')">Back</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="$emit('submit')">Ok</v-btn>
    </v-layout>

  </div>

</template>

<script>
import ColorBlocks from '@/components/customizer/ColorBlocks.vue'

export default {
  name:'card-color',
  components: {
    ColorBlocks,
  },
  props: {
    value: {type:String, default:null},
    colors : {type:Array, default:undefined},
  },
  data() {
    return {
    }
  },
  methods: {
  },
}
</script>
